<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const { subtotal, totalPrice, shippingTotal, cart } = useCart()
const { getFormattedPrice } = usePrice()
</script>
<template>
  <div class="totals f-18">
    <div class="line subtotal">
      <div>{{ t('shop.cartPage.summaryTable.subtotal') }}</div>
      <div>{{ getFormattedPrice(subtotal) }}</div>
    </div>
    <div class="line shipping">
      <div>{{ t('shop.cartPage.summaryTable.shipping') }}</div>
      <div>{{ getFormattedPrice(shippingTotal) }}</div>
    </div>
    <div class="line total">
      <div class="f-bold">{{ t('shop.cartPage.summaryTable.total') }}</div>
      <div class="f-21 f-bold">{{ getFormattedPrice(totalPrice) }}</div>
    </div>
    <div v-if="cart?.price.netPrice" class="line net-price">
      <div>{{ t('shop.cartPage.summaryTable.totalNetAmount') }}</div>
      <div>{{ getFormattedPrice(cart.price.netPrice) }}</div>
    </div>
    <div v-for="(tax, index) in cart?.price.calculatedTaxes" :key="index" class="line tax">
      <div>
        {{ t('shop.cartPage.summaryTable.plus') }} {{ tax.taxRate }} % {{ t('shop.cartPage.summaryTable.VAT') }}
      </div>
      <div>{{ getFormattedPrice(tax.tax) }}</div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.totals {
  .line {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: baseline;
    padding: 16px 0;
    div {
      text-align: right;
      &:first-child {
        text-align: left;
      }
    }
    &.subtotal {
      border-bottom: 1px solid var(--c-line-light);
    }
    &.shipping {
      border-bottom: 1px solid var(--c-line-light);
    }
    &.total {
      color: var(--c-primary);
    }
    &.tax,
    &.net-price {
      padding: 4px 0;
      color: var(--c-gray-75);
    }
  }
}
</style>
